import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const AssetGroupTreeAssigmentServiceConfig = {
  name: "AssetGroupTreeAssigment",
  annotations: []
} as ServiceConfig;